export const CapitalizeFirstLetter = (text: String) => {
    return text.charAt(0).toLocaleUpperCase() + text.slice(1);
};

export default CapitalizeFirstLetter;
